import { createDemoWorld, createWorldOfSize, type MapSize, MapTheme, writeSnapshot } from '@am/sim';
import type { SaveStart } from './store';

/**
 * A new game on the ready-made demo airport (see scenario.ts in the sim): built like a save,
 * so it starts offline or as a co-op host the same way. Saving later creates a new slot.
 */
/**
 * A new, empty game on a map of another size than the standard one, or on another landscape
 * (MapTheme: the desert, the mountains); started like a save.
 */
export function sizedStart(airportName: string, size: MapSize, theme = 0): SaveStart {
  const seed = Math.floor(Math.random() * 0x7fffffff);
  return {
    id: `save-${Date.now().toString(36)}`,
    name: airportName,
    data: writeSnapshot(createWorldOfSize(seed, size, airportName, theme)),
  };
}

export function demoStart(airportName: string, theme = 0): SaveStart {
  const seed = Math.floor(Math.random() * 0x7fffffff);
  return {
    id: `save-${Date.now().toString(36)}`,
    name: airportName,
    data: writeSnapshot(createDemoWorld(seed, airportName, theme)),
  };
}

/**
 * How a new game starts: the ready-made airport, a large map or another landscape go as a save
 * (the world made here); the plain green standard map is made from a seed.
 */
export function newGameSave(
  airportName: string,
  demo: boolean,
  large: boolean,
  theme: number,
): SaveStart | null {
  if (demo) return demoStart(airportName, theme);
  if (large || theme !== MapTheme.Temperate)
    return sizedStart(airportName, large ? 'large' : 'normal', theme);
  return null;
}
